function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { FaFacebook, FaLink, FaLinkedin, FaYoutube, FaFlickr, FaInstagram } from 'react-icons/fa';
import { RiTwitterXFill } from 'react-icons/ri';
var PlatformIcons = {
    fb: FaFacebook,
    tw: RiTwitterXFill,
    lin: FaLinkedin,
    yt: FaYoutube,
    insta: FaInstagram,
    flckr: FaFlickr,
    none: FaLink
};
export default function PlatformIcon(_0) {
    var type = _0.type, props = _object_without_properties(_0, [
        "type"
    ]);
    var Icon = PlatformIcons[type];
    return /*#__PURE__*/ React.createElement(Icon, props);
}

//# sourceMappingURL=PlatformIcon.js.map